import React from 'react';
import { AiOutlineCheck } from 'react-icons/ai';
import './ConfirmModal.css';

const ReactivateUserModal = ({
  open,
  reactivatingUserId,
  users,
  loading,
  error,
  message,
  onClose,
  onConfirm,
}) => {
  if (!open || !reactivatingUserId) return null;

  const userEmail = users.find((u) => u.id === reactivatingUserId)?.email;

  return (
    <div className="cm-overlay" onClick={onClose}>
      <div className="cm-modal" onClick={(e) => e.stopPropagation()}>

        <div className="cm-header">
          <div className="cm-icon cm-icon--confirm">
            <AiOutlineCheck />
          </div>
          <div className="cm-title-group">
            <h3>Reactivate User</h3>
            <p>Restore account access</p>
          </div>
          <button className="cm-close" onClick={onClose} aria-label="Close">✕</button>
        </div>

        <div className="cm-body">
          {error   && <div className="cm-message cm-message--error">{error}</div>}
          {message && <div className="cm-message cm-message--success">{message}</div>}

          <div className="cm-info-box">
            <strong>User will regain access</strong>
            <p>This user will be able to log in and use their account again.</p>
          </div>

          {userEmail && (
            <div className="cm-user-box">
              <span>Selected user</span>
              <strong>{userEmail}</strong>
            </div>
          )}
        </div>

        <div className="cm-footer">
          <button className="cm-btn cm-btn--cancel" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            className="cm-btn cm-btn--confirm"
            onClick={() => onConfirm(reactivatingUserId)}
            disabled={loading}
          >
            {loading ? 'Reactivating…' : 'Reactivate'}
          </button>
        </div>

      </div>
    </div>
  );
};

export default ReactivateUserModal;
